<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="row">
        <div class="col-xs-6">
          <h1>Install Or Repair VPN Auth Server</h1>
        </div>
        <div class="col-xs-6 mandatoryDiv">
          <span class="mandatory_color">(*)</span>
          <span class="letter-right"> Marked are required field</span>
        </div>
      </div>
    </section>
    <section class="content">
      <div class="row">
        <div class="col-sm-12">
          <div class="alert alert-info" v-if="alert_message">
            {{ alert_message }}
          </div>
        </div>
        <form role="form">
          <div class="col-sm-6">
            <div class="box">
              <div class="box-header">
                <h3 class="box-title">Required Information</h3>
              </div>
              <div class="box-body form-box-body form-horizontal">
                <div class="form-group">
                  <label class="col-md-4 control-label"
                    >Radius Server IP <span class="mandatory_horizontal">*</span></label
                  >
                  <div class="col-md-8">
                    <input
                      name="server_ip"
                      v-model="server_ip"
                      id="server_ip"
                      class="form-control input-sm"
                      value=""
                      placeholder="Radius Server IP"
                      type="text"
                      disabled
                    />
                    <label v-if="error_server_ip" class="error" for="name">{{
                      error_server_ip
                    }}</label>
                  </div>
                </div>
                
                <div style="margin-top: 25px" class="form-group">
                  <div class="col-md-12 btnCenter">
                    <div v-if="!loading">
                      <a
                        @click="formSubmit"
                        class="btn btn-submit btn-submit-big"
                      >
                        {{ vpn_status == 3 ? "Install" : "Repair" }}
                      </a>
                    </div>
                    <div v-else>
                      <span
                        style="
                          font-weight: 700;
                          font-size: 14px;
                          color: orangered;
                          margin-bottom: 10px;
                        "
                        >Server Provisioning Start. Please Wait.
                        <img :src="loaderGif" alt="Loading" />
                      </span>
                      <div
                        class="alert text-center alert-warning alert-dismissible text-left font__family-montserrat font__size-16 font__weight-light brk-library-rendered rendered show"
                        role="alert"
                        data-brk-library="component__alert"
                      >
                        <i
                          class="start-icon fa fa-info-circle faa-shake animated"
                        ></i>
                        <strong class="font__weight-semibold"
                          >Attention!</strong
                        >
                        Please Don't Reload When Server Provisioning.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="box">
              <div class="box-header">
                <h3 class="box-title">Console</h3>
              </div>
              <div class="box-body form-box-body form-horizontal">
                <pre
                  :class="output.installation_status == 1 ? 'success' : 'error'"
                >
                   <div class="success" v-if="loading">
                     Processing....
                  </div>
                  {{ output.auth_server_log }}
                </pre>
              </div>
            </div>
          </div>
        </form>
      </div>
    </section>
  </div>
</template>
<script>
import axios from "axios";

export default {
  name: "VpnAuthServerInstaller",
  data() {
    return {
      loaderGif: "/assets/img/provisoning.gif",
      value: null,
      id: "",
      server_ip: "",
      vpn_status: "",
      output: "",
      loading: false,
      isEditing: false,
      alert_message: "",
      LabelFormName: "Add New",
      error_server_ip: false,
    };
  },
  mounted: function () {
    $(".select2").select2();
  },
  created() {
    loader.show();
    var rootObject = this;
    if (this.$route.params.id) {
      rootObject.isEditing = true;
      rootObject.id = this.$route.params.id;
      rootObject.getEditData();
    }
  },
  methods: {
    labelWithCity({ label, city }) {
      return `${label} — [${city}]`;
    },
    getEditData() {
      loader.show();
      let rootObject = this;
      rootObject.LabelFormName = "Edit";
      axios
        .get("radius-auth-server/" + rootObject.id)
        .then(function (response) {
          rootObject.server_ip = response.data.ip;
          rootObject.vpn_status = response.data.vpn_status;

          loader.hide();
        })
        .catch(function (error) {
          let alertmessage = "";
          for (var prop in error.response.data) {
            alertmessage += " " + error.response.data[prop];
          }
          console.log(alertmessage);
          rootObject.alert_message = alertmessage;
          loader.hide();
          rootObject.com_errorHandel(error);
        });
    },

    formSubmit(e) {
      e.preventDefault();
      var rootObject = this;
      var result = this.fromValidation();
      if (result) {
        setTimeout(function () {
          rootObject.error_ip = false;
        }, 5000);
        return 0;
      }

      //loader.show();
      rootObject.loading = true;
      let querystr = "";
      const form = new FormData();
      form.append("server_id", this.id);
      form.append("server_ip", this.server_ip);
      var config = {
        headers: { "Content-Type": "multipart/form-data" },
      };

      axios
        .post("radius-server-provisioning", form, config)
        .then(function (response) {
          console.log(response);
          rootObject.output = response.data;
          rootObject.loading = false;
          loader.hide();
        })
        .catch(function (error) {
          console.log(error);
          let alertmessage = "";
          rootObject.loading = false;
          // loader.hide();
          rootObject.com_errorHandel(error);
          for (var prop in error.response.data) {
            alertmessage += " " + error.response.data[prop];
          }
          rootObject.alert_message = alertmessage;
        });

      setTimeout(function () {
        rootObject.alert_message = "";
      }, 5000);
    },

    onFileSelected(event) {
      //console.log(event.target.files[0]);
      this.wireguard_file = event.target.files[0];
    },

    fromValidation(reset = false) {
      var has_error = false;

      if (!this.server_ip) {
        this.error_server_ip = "This field is required";
        has_error = true;
      }

      if (has_error) {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>

<style scoped>
.success {
  color: green;
}
.error {
  color: orangered;
}
pre {
  height: auto;
  max-height: 70vh;
  overflow: auto;
  background-color: #eeeeee;
  word-break: normal !important;
  word-wrap: normal !important;
  white-space: pre !important;
}

.alert > .start-icon {
  margin-right: 0;
  min-width: 20px;
  text-align: center;
}

.alert > .start-icon {
  margin-right: 5px;
}

.greencross {
  font-size: 18px;
  color: #25ff0b;
  text-shadow: none;
}

.alert-simple.alert-success {
  border: 1px solid rgba(36, 241, 6, 0.46);
  background-color: rgba(7, 149, 66, 0.12156862745098039);
  box-shadow: 0px 0px 2px #259c08;
  color: #0ad406;
  text-shadow: 2px 1px #00040a;
  transition: 0.5s;
  cursor: pointer;
}
.alert-success:hover {
  background-color: rgba(7, 149, 66, 0.35);
  transition: 0.5s;
}
.alert-simple.alert-info {
  border: 1px solid rgba(6, 44, 241, 0.46);
  background-color: rgba(7, 73, 149, 0.12156862745098039);
  box-shadow: 0px 0px 2px #0396ff;
  color: #0396ff;
  text-shadow: 2px 1px #00040a;
  transition: 0.5s;
  cursor: pointer;
}

.alert-info:hover {
  background-color: rgba(7, 73, 149, 0.35);
  transition: 0.5s;
}

.blue-cross {
  font-size: 18px;
  color: #0bd2ff;
  text-shadow: none;
}

.alert-simple.alert-warning {
  border: 1px solid rgba(241, 142, 6, 0.81);
  background-color: rgba(220, 128, 1, 0.16);
  box-shadow: 0px 0px 2px #ffb103;
  color: #ffb103;
  text-shadow: 2px 1px #00040a;
  transition: 0.5s;
  cursor: pointer;
}

.alert-warning:hover {
  background-color: rgba(220, 128, 1, 0.33);
  transition: 0.5s;
}

.warning {
  font-size: 18px;
  color: #ffb40b;
  text-shadow: none;
}

.alert:before {
  content: "";
  position: absolute;
  width: 0;
  height: calc(100% - 44px);
  border-left: 1px solid;
  border-right: 2px solid;
  border-bottom-right-radius: 3px;
  border-top-right-radius: 3px;
  left: 0;
  top: 50%;
  transform: translate(0, -50%);
  height: 20px;
}

.fa-times {
  -webkit-animation: blink-1 2s infinite both;
  animation: blink-1 2s infinite both;
}

/**
 * ----------------------------------------
 * animation blink-1
 * ----------------------------------------
 */
@-webkit-keyframes blink-1 {
  0%,
  50%,
  100% {
    opacity: 1;
  }
  25%,
  75% {
    opacity: 0;
  }
}
@keyframes blink-1 {
  0%,
  50%,
  100% {
    opacity: 1;
  }
  25%,
  75% {
    opacity: 0;
  }
}
</style>
